import React from 'react'
import { Button } from '@material-ui/core'
export default function Confirm_rbk_result(props) {
    let { modal_data } = props

    return (
        <div>
            <div className='confirm-container text-start'>
                <h4>Anda yakin ingin menyelesaikan pengisian form?</h4>
                {/* <ul>

                <li style={{textAlign: "start"}}>Form yang ter-submit akan terkunci dan diperiksa oleh Admin / Konsultan. </li>
                <li style={{textAlign: "start"}}>
                    Jika anda ingin mengedit kembali, Anda perlu menghubungi konsultan & PIC dari kantor anda.
                </li>
                </ul> */}
                <div className='div-flex' style={{flexDirection: "column"}}>
                    {/* <MuiThemeProvider theme={themeButton}> */}
                    <div>
                        
                    <Button onClick={() => modal_data.action_ya()} size='small' color='white' variant='contained' className='btn-remove-capital btn-rounded' style={{width: "100%"}}>Simpan Draft</Button>
                    <p style={{margin: "0px"}}>Simpan sementara, bisa diubah nanti.</p>
                    <p style={{marginTop: "0px"}}>Kembali ke halaman depan</p>

                    </div>
                    <div>
                    <Button onClick={() => modal_data.action_no()} size='small' color='primary' variant='contained' className='btn-remove-capital btn-rounded w-100'  style={{width: "100%"}}>Simpan dan Kirim</Button>

                    <p style={{marginTop: "0px", marginBottom: "1rem"}}>Simpan & kunci sementara untuk direview</p>
                    </div>
                    {/* </MuiThemeProvider> */}
                </div>
            </div>
        </div>
    )
}
